<template>
  <div class="w-100" :class="dynamicClass">
    <span v-for="i in new Array(8)" :key="i" class="material-icons md-12">emergency</span>
  </div>
</template>

<script>
export default {
  name: 'PasswordField',
  props: {
    content: {
      type: Boolean,
    },
    inDetailView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dynamicClass() {
      return this.inDetailView || this.isCardView ? 'text-start' : 'text-center'
    },
    isCardView() {
      return this.$get('viewMode') === 'cardView'
    },
  },
}
</script>
